/**
 * Uppercase the first letter and leave the rest of the string unchanged.
 * @note alternative to lodash `capitalize()` which lowercases the rest of the characters.
 */
export const capitalize = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);
